import * as React from "react";
import { Button } from "@/components/ui/button";
import { Feature, Polygon } from "geojson";
import useToggle from "hooks/use-toggle";
import { CloseIcon } from "components/icons";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type CurbZoneMultiDetailProps = {
  curbZones: Feature<Polygon>[];
  resetState: () => void;
  openCurbZoneMultiModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleRemoveMultiCurbZone: (input: string[]) => void;
};

export const CurbZoneMultiDetail = ({
  curbZones,
  resetState,
  openCurbZoneMultiModal,
  handleRemoveMultiCurbZone,
}: CurbZoneMultiDetailProps) => {
  const [openConfirm, setOpenConfirm] = useToggle(false);
  const removeMultiCurbZone = () => {
    const curbZoneIds = curbZones.map((item) => item.id) as string[];
    handleRemoveMultiCurbZone(curbZoneIds);
    resetState();
  };
  return (
    <>
      <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-10">
        <div className="flex justify-end h-6 cursor-pointer">
          <CloseIcon className="text-white w-4 h-4" onClick={resetState} />
        </div>
        <div className="flex gap-8 py-2">
          <span className="text-sm text-secondary">Currently selecting</span>
          <span className="text-sm text-secondary text-right">{curbZones?.length} Curb Zones</span>
        </div>
        <div className="flex justify-between">
          <Button onClick={setOpenConfirm} variant="destructive">
            Delete
          </Button>
          <Button onClick={() => openCurbZoneMultiModal(true)} variant="secondary">
            Edit
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete curb zones</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete the curb zones?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={setOpenConfirm}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={removeMultiCurbZone}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
